import { useState } from "react";
import { Button } from "react-bootstrap";

import { IObject } from "../../../../shared/utils/utils";
import ReadonlyWidgetComponent from "../../../components/widgets-layout/readonly-widget-component/readonly-widget-component";
import { IWidgetLayout } from "../../../components/widgets-layout/widget-component/widget-component";
import { Widget } from "../../../components/widgets-layout/widget-utils";
import "./create-new-event.scss";

interface ICreateNewEventRowConfig {
  eventCaptureId: string;
  eventData: IObject;
  layout: IWidgetLayout | undefined;
  onDataChanged: (eventData: IObject) => void;
  onCreateEvent: () => void;
}

const CreateNewEvent = ({
  eventData,
  layout,
  onDataChanged,
  onCreateEvent
}: ICreateNewEventRowConfig) => {
  const [formValid, setFormValid] = useState<boolean | undefined>();

  const requiredFieldsFilledIn = () => {
    if (!layout) {
      return false;
    }
    const requiredFields = layout?.layoutItems
      ?.filter((item: any) => item.required) // eslint-disable-line
      ?.map((item: Widget) => item.id) || [];

    return requiredFields.length === 0 || requiredFields.every(
      (field: string) => {
        const value = eventData[field];
        return value !== undefined && value !== null && value !== "";
      }
    );
  };

  const handleAddNewEvent = () => {
    if (!requiredFieldsFilledIn()) {
      setFormValid(false);
      return; 
    }

    setFormValid(true);
    onCreateEvent();
  };

  const handleDataChanged = (newValue: string, key?: string) => {
    if (!key) {
      return;
    }

    const updatedEventData = {...eventData, [key]: newValue};
    onDataChanged(updatedEventData);

    if (formValid === false) {
      setFormValid(requiredFieldsFilledIn());
    }
  };

  return (
    <div className="createNewEvent">
      {layout && 
        <ReadonlyWidgetComponent
          layout={layout}
          data={eventData}
          onDataChanged={handleDataChanged}
        />
      }
      
      {formValid === false && <p className="createNewEvent-toast">Please fill all required fields.</p>}
      <Button
        onClick={handleAddNewEvent}
        className="createNewEvent-addButton"
      >
        Submit
      </Button>
    </div>
  );
};

export default CreateNewEvent;
